<div class="layout-content" style="margin-top:20px;">
    <form (ngSubmit)="submit()" [formGroup]="rowForm">
        <div class="grid">
            <div [ngClass]="col4Responsive('left')" class="pt-2 sm:pt-3">
               <div class="flex justify-content-between flex-wrap" [ngClass]="showErrors(this.f.ContentType, 'borderRow')">
                  <div class="flex align-items-center justify-content-center" [ngClass]="showErrors(this.f.ContentType, 'label')">{{ 'ROW_TYPE' | translate }} *</div>
                  <div class="flex align-items-center justify-content-center" [ngClass]="showErrors(this.f.ContentType, 'borderInput')">
                     <p-dropdown [options]="types"  formControlName="ContentType" optionLabel="name"
                        [ngClass]="dynamicInputTextWidth()"
                        styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
                        placeholder="{{ 'ROW_TYPE' | translate }}"
                        optionValue="code" dataKey="code" >
                     </p-dropdown>
                  </div>
               </div>
               <small *ngIf="showErrorRequiredMessage(this.f.ContentType)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}</small>
            </div>
            <div class="col-12 flex justify-content-center">
                <span class="p-float-label">
                    <textarea id="float-input" [rows]="isRowText()?10:1" cols="80" pInputTextarea [formControlName]="'ContentIt'"></textarea>
                    <label for="float-input">{{ 'ITALIANO' | translate }}*</label>
                </span>
            </div>
            <div class="col-12 flex justify-content-center">
                <span class="p-float-label">
                    <textarea id="float-input" [rows]="isRowText()?10:1" cols="80" pInputTextarea formControlName="ContentEn"></textarea>
                    <label for="float-input">{{ 'INGLESE' | translate }}*</label>
                </span>
            </div>
            <div class="col-12 flex justify-content-center">
                <span class="p-float-label">
                    <textarea id="float-input" [rows]="isRowText()?10:1" cols="80" pInputTextarea formControlName="ContentEs"></textarea>
                    <label for="float-input">{{ 'SPAGNOLO' | translate }}*</label>
                </span>
            </div>
            <div class="col-12 flex justify-content-center">
                <span class="p-float-label">
                    <textarea id="float-input" [rows]="isRowText()?10:1" cols="80" pInputTextarea formControlName="ContentDe"></textarea>
                    <label for="float-input">{{ 'TEDESCO' | translate }}*</label>
                </span>
            </div>
            <div class="col-12 flex justify-content-center">
                <span class="p-float-label">
                    <textarea id="float-input" [rows]="isRowText()?10:1" cols="80" pInputTextarea formControlName="ContentFr"></textarea>
                    <label for="float-input">{{ 'FRANCESE' | translate }}*</label>
                </span>
            </div>
            <div class="col-12 flex justify-content-center">
                <span class="p-float-label">
                    <textarea id="float-input" [rows]="isRowText()?10:1" cols="80" pInputTextarea formControlName="ContentNl"></textarea>
                    <label for="float-input">{{ 'OLANDESE' | translate }}*</label>
                </span>
            </div>
            <div class="col-12 flex justify-content-center">
                <span class="p-float-label">
                    <textarea id="float-input" [rows]="isRowText()?10:1" cols="80" pInputTextarea formControlName="ContentPl"></textarea>
                    <label for="float-input">{{ 'POLACCO' | translate }}*</label>
                </span>
            </div>
            <div class="col-12 flex justify-content-center">
                <span class="p-float-label">
                    <textarea id="float-input" [rows]="isRowText()?10:1" cols="80" pInputTextarea formControlName="ContentRu"></textarea>
                    <label for="float-input">{{ 'RUSSO' | translate }}*</label>
                </span>
            </div>
            <div class="col-12 flex justify-content-center">
                <span class="p-float-label">
                    <textarea id="float-input" [rows]="isRowText()?10:1" cols="80" pInputTextarea formControlName="ContentSk"></textarea>
                    <label for="float-input">{{ 'SLOVENO' | translate }}*</label>
                </span>
            </div>
        </div>

        <div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
            <button type="submit" pButton pRipple
                [disabled]="!rowForm.valid" label="{{ 'CONFIRM' | translate }}"
                class="p-button-primary text-xl font-normal mt-3 sm:mt-0 mr-0 sm:mr-1"
                [ngClass]="dynamicButtonWidth()">
            </button>
            <button type="button" pButton pRipple (click)="closeDialog()"
                    label="{{ 'CANCEL' | translate }}"
                    class="p-button-secondary text-xl font-normal mt-3 sm:mt-0 ml-0 sm:ml-1"
                    [ngClass]="dynamicButtonWidth()">
            </button>
        </div>
    </form>
</div>
